import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { sanitize_id } from '../misc/CommonFunctions.ts';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

export function MultipleSelectChip({ id, names, selected, setSelected, style, sx }) {
    const theme = useTheme();

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;

        setSelected(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleDelete = (chipToDelete) => (event) => {
        event.stopPropagation();

        const selectedCopy = [...selected];
        const selectedFiltered = selectedCopy.filter((chip) => chip !== chipToDelete);
        setSelected(selectedFiltered);
    }



    return (
        <div>
            <Select
                labelId="demo-multiple-chip-label"
                id={id}
                multiple
                style={style}
                value={selected}
                onChange={handleChange}
                sx={sx}

                input={<OutlinedInput label="" />}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>


                        {selected.map((value) => (
                            <Chip
                                id={sanitize_id(id + "_chip_" + value)}
                                key={value}
                                label={value}

                                onDelete={handleDelete}
                                onClick={handleDelete}
                                deleteIcon={
                                    <IconButton
                                        onMouseDown={handleDelete(value)}
                                        size="small"
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                }
                            />
                        ))}
                    </Box>
                )}
                MenuProps={MenuProps}
            >
                {names.map((name) => (
                    <MenuItem
                        id={sanitize_id(id + "_" + name)}
                        key={name}
                        value={name}
                        style={getStyles(name, selected, theme)}
                    >
                        {name}
                    </MenuItem>
                ))}
            </Select>
        </div >
    );

}